import { render } from "./EducationForm.vue?vue&type=template&id=973f6404&scoped=true"
import script from "./EducationForm.vue?vue&type=script&lang=js"
export * from "./EducationForm.vue?vue&type=script&lang=js"

import "./EducationForm.vue?vue&type=style&index=0&id=973f6404&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973f6404"]])

export default __exports__